import { BodyText, CSPR, PrecisionCase, FlexColumn, FlexRow, SvgIcon, Tooltip } from '@make-software/cspr-design';
import React from 'react';

import InfoIcon from '@/assets/icons/ic-info.svg';

import { Divider, PaymentAmountContainer } from './styled';
import { ITransactionPaymentProps } from './types';

export const PaymentAmount: React.FC<ITransactionPaymentProps> = ({
  category,
  hint,
  amount,
  formattedFiatAmount = null,
  withDivider = true,
  canProceed = true,
}) => (
  <FlexColumn gap={12}>
    {withDivider && <Divider />}
    <FlexRow justify='space-between'>
      <PaymentAmountContainer gap={4} align='center'>
        <BodyText size={3} scale='xs' lineHeight='xs' variation='darkGray'>
          {category}
        </BodyText>
        {hint && <Tooltip
          scale={'xs'}
          lineHeight={'xs'}
          paddingScale={1}
          limitWidth
          tooltipContent={hint}
        >
          <SvgIcon src={InfoIcon} />
        </Tooltip>}
      </PaymentAmountContainer>
      <FlexColumn gap={4} align='flex-end'>
        <BodyText monotype size={3} scale='xs' lineHeight='xs' variation={canProceed ? 'black' : 'gray'}>
          <CSPR motes={amount} precisionCase={PrecisionCase.small} />
        </BodyText>
        {formattedFiatAmount && (
          <BodyText size={1} scale='sm' variation={canProceed ? 'black' : 'gray'} lineHeight='xs'>
            {formattedFiatAmount}
          </BodyText>
        )}
      </FlexColumn>
    </FlexRow>
  </FlexColumn>
);

export const TransactionPayment: React.FC<ITransactionPaymentProps> = (props) =>
  <PaymentAmount
    {...props}
    category="Transaction payment"
    hint="Transaction payment specifies the maximum amount that can be charged for executing the transaction. 75% of unused gas is refunded for successfully executed transaction."
  />;
